"use client";

import React from "react";
import { ShieldCheck, FileText, BadgeCheck, ThumbsUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const guarantees = [{
  icon: BadgeCheck,
  title: "FDACS LICENSED",
  description: "Certified Pest & Termite Operator"
}, {
  icon: ShieldCheck,
  title: "FULLY INSURED",
  description: "Comprehensive protection for your home"
}, {
  icon: ThumbsUp,
  title: "LOCALLY OWNED",
  description: "Serving Punta Gorda & surrounding areas"
}, {
  icon: FileText,
  title: "FREE INSPECTION",
  description: "Detailed reports and honest estimates"
}];
export default function TheResellHubGuarantee() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: badgesRef,
    isVisible: areBadgesVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222984" id="certified-protection" className="bg-background border-t border-b border-primary py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground tracking-tight uppercase">
            Certified Protection
          </h2>
        </div>

        <div ref={badgesRef} className={`flex flex-col md:flex-row flex-wrap justify-center items-start gap-10 md:gap-8 lg:gap-16 transition-all duration-1000 delay-200 ease-out ${areBadgesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {guarantees.map((guarantee, i) => {
          const Icon = guarantee.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center w-full md:w-[220px] group">
                <div className="relative mb-5 flex items-center justify-center w-20 h-20 rounded-md bg-primary border-4 border-primary shadow-none transition-transform duration-300 group-hover:scale-105 [clip-path:polygon(30%_0%,_70%_0%,_100%_30%,_100%_70%,_70%_100%,_30%_100%,_0%_70%,_0%_30%)]">
                  <Icon className="w-10 h-10 text-background" strokeWidth={2} />
                </div>
                <h3 className="font-default text-sm font-bold text-foreground mb-2 leading-tight uppercase tracking-wider">
                  {guarantee.title}
                </h3>
                <p className="font-serif text-foreground text-lg leading-relaxed max-w-[200px]">
                  {guarantee.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}